import getShineStartVerificationErrors from 'features/Onboarding/modules/ShineStartVerification/libs/getShineStartVerificationErrors';
import getShineStartVerificationStatus from 'features/Onboarding/modules/ShineStartVerification/libs/getShineStartVerificationStatus';

import { State } from '../../machine';
import model from '../../machine/model';
import locales from './locales';
import { GetVerificationStep } from './types';

// shineStart.documents type is (ShineStartDocument| null)[]
// this function makes ts happy
function isNotNull<D>(doc: D): doc is NonNullable<D> {
  return Boolean(doc);
}

const getShineStartVerificationStep: GetVerificationStep = ({
  verificationData,
}) => {
  const { company } = verificationData.viewer;
  const documents = company.shineStart?.documents?.filter(isNotNull) || [];

  const status = getShineStartVerificationStatus({
    documents,
    isShineStart: company.isShineStart,
  });

  return {
    errors: getShineStartVerificationErrors({
      documents,
    }),
    id: State.SHINE_START_VERIFICATION,
    metadata: {
      event: model.events.GO_SHINE_START_VERIFICATION(),
      iconName: 'company',
      label: locales.shineStart,
    },
    status,
  };
};

export default getShineStartVerificationStep;
